import Promo from './Promo.mjs';
import NoPromos from './NoPromos.mjs';

export default function Promos({ promos, promoTypes, promoPerks, propertyPerks, versePerks }) {
  let content = <NoPromos />;

  if (promos && promos.events.length > 0) {
    const promoElements = promos.events.map(p => {
      return (
        <Promo
          key={'promo-' + p.eventId}
          promo={p}
          promoTypes={promoTypes}
          promoPerks={promoPerks}
          propertyPerks={propertyPerks}
          versePerks={versePerks}
        />
      );
    });

    content = <div id="promos-content" tabIndex="0" className="d-flex flex-column gap-3">{promoElements}</div>;
  }

  return (
    content
  );
}
